import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  makeStyles,
  mergeClasses,
} from '@fluentui/react-components';

export type DraftInsertAction = 'end' | 'replace' | 'cancel';

interface DraftInsertPromptProps {
  open: boolean;
  onResolve: (action: DraftInsertAction) => void;
}

const SIGNUS_BLUE = '#1014f5';
const SIGNUS_BLUE_HOVER = '#2a2eff';
const SIGNUS_BLUE_PRESSED = '#0a0dcc';

const useStyles = makeStyles({
  content: {
    fontSize: '14px',
  },
  button: {
    minWidth: 'auto',
    paddingLeft: '16px',
    paddingRight: '16px',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
    '& *': { whiteSpace: 'nowrap' },
  },
  secondaryText: {
    color: SIGNUS_BLUE,
    ':hover': { color: SIGNUS_BLUE_HOVER },
    ':hover:active': { color: SIGNUS_BLUE_PRESSED },
  },
  primary: {
    backgroundColor: SIGNUS_BLUE,
    border: `1px solid ${SIGNUS_BLUE}`,
    color: '#ffffff',
    ':hover': {
      backgroundColor: SIGNUS_BLUE_HOVER,
      border: `1px solid ${SIGNUS_BLUE_HOVER}`,
      color: '#ffffff',
    },
    ':hover:active': {
      backgroundColor: SIGNUS_BLUE_PRESSED,
      border: `1px solid ${SIGNUS_BLUE_PRESSED}`,
      color: '#ffffff',
    },
  },
});

const DraftInsertPrompt: React.FC<DraftInsertPromptProps> = ({ open, onResolve }) => {
  const styles = useStyles();
  return (
    <Dialog
      open={open}
      onOpenChange={(_, data) => {
        if (!data.open) onResolve('cancel');
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Insert agreement</DialogTitle>
          <DialogContent className={styles.content}>
            Add it to the end of the current document, or replace everything in the document with
            it? Replacing cannot be undone.
          </DialogContent>
          <DialogActions>
            <Button
              className={mergeClasses(styles.button, styles.primary)}
              appearance="primary"
              onClick={() => onResolve('end')}
            >
              Insert at end
            </Button>
            <Button
              className={mergeClasses(styles.button, styles.secondaryText)}
              onClick={() => onResolve('replace')}
            >
              Replace document
            </Button>
            <Button
              className={mergeClasses(styles.button, styles.secondaryText)}
              onClick={() => onResolve('cancel')}
            >
              Cancel
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default DraftInsertPrompt;
